module.exports = __webpack_public_path__ + "media/icons/smartsearch/colors/purple-835e39e7c8d46dc37a8f3c2637d58078.png";